import { watch, onScopeDispose } from 'vue';
import { useAuth, validateSession } from '@/composables/useAuth';
import { usePortfolioBalanceStore } from '@/stores/portfolioBalance';
import { useDocumentPoll } from '@/composables/useDocumentPoll';
import { POLL_MS } from '@/utils/deposit-chain-monitor';

export function usePortfolioBalancePoll() {
  const { isLoggedIn } = useAuth();
  const portfolioStore = usePortfolioBalanceStore();
  let disposed = false;

  async function tickPortfolioBalance() {
    if (disposed || !isLoggedIn.value || !validateSession()) return;
    if (portfolioStore.watchPhase === 'fast') return;

    await portfolioStore.refresh({ silent: true, force: false });
  }

  const poll = useDocumentPoll(tickPortfolioBalance, {
    intervalMs: POLL_MS.slow,
    enabled: () => isLoggedIn.value,
    watchSources: () => isLoggedIn.value,
    scope: 'portfolio-balance',
    skipIfBusy: true,
  });

  watch(isLoggedIn, (loggedIn, wasLoggedIn) => {
    if (!loggedIn) return;
    if (!wasLoggedIn) poll.tick();
  });

  onScopeDispose(() => {
    disposed = true;
    poll.stop();
  });

  return { tickPortfolioBalance };
}
